// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__f4XqQ","Borderless":"Modal_Borderless__2g3TM","row":"Modal_row__2fFLJ"};